import React, { FC } from "react";
import { PlanType } from "../../types";

interface PlanCardProps {
  plan: PlanType;
  currPlanId: string;
  handleSelectPlan: (planId: string) => void;
}
const PlanCard: FC<PlanCardProps> = ({
  plan,
  currPlanId,
  handleSelectPlan,
}) => {
  // useEffect(() => {
  //   console.log(currPlanId, plan.id);
  // }, [vehicle?.plan?.id]);

  return (
    <div
      className={`w-[90%] lg:w-[45%] max-w-[458%] min-h-[525px] flex flex-shrink-0 flex-col bg-white border-[0.1px]  rounded-lg shadow-xl shadow-[#667085] ${
        currPlanId === plan?.id ? "border-lightGreen" : "border-[#667085]"
      } `}
    >
      <div className="w-full flex flex-col p-[32px] gap-[32px] border-b-[0.5px] border-[#667085] ">
        {/* <div className="flex w-full justify-between">
          <h1 className="font-Inter font-medium text-[#667085] text-[18px] leading-7 ">
            Basic Plan
          </h1>
          <p className=" text-midGreen px-3 py-1 font-Inter font-medium text-sm leading-5 bg-[#F9F5FF]  rounded-lg">
            Popular
          </p>
        </div> */}
        <div className="flex w-full flex-col gap-[16px]">
          <div className="flex gap-1 items-end  ">
            <p className=" font-Inter font-bold text-[#101828] tracking-[-1.2px] text-[30px] leading-[42px] ">
              {plan.name}
            </p>
            {/* <span className=" font-Inter font-medium text-[#667085] text-[12px] leading-4 ">
              insurance plan
            </span> */}
          </div>
          {/* <p className="font-Inter font-normal text-[#667085] text-[16px] leading-7 ">
            Basic features for up to 10 users.
          </p> */}
        </div>
        <button
          type="button"
          onClick={() => {
            handleSelectPlan(plan.id);
            // dispatch(
            //   setVehicle({
            //     plan: {
            //       id: plan.id,
            //     },
            //   })
            // );
          }}
          className={`w-full py-4 text-center text-white rounded-lg font-Inter text-base font-medium leading-6 ${
            currPlanId === plan?.id ? " bg-lightGreen" : "bg-midGreen"
          }`}
        >
          {currPlanId === plan?.id ? "Selected" : "Select Plan"}
        </button>
      </div>

      <div className="w-full flex flex-col p-[32px] gap-[32px] ">
        <div className="flex flex-col gap-3 ">
          <h1 className=" uppercase font-Inter text-base font-semibold text-[#101828]">
            Features
          </h1>
          {/* <p className=" font-Inter text-base font-normal leading-6 text-[#667085] ">
            Everything in <span className=" font-semibold px-1">Starter</span>
            plus....
          </p> */}
        </div>
        <div className="">
          <ul className="list-image-[url(./assets/images/checkIcon.svg)] text-start items-center  gap-3 list-inside font-Inter text-base font-normal leading-6 text-[#667085] ">
            {plan?.features?.length &&
              plan.features.map((feature, index) => (
                <li
                  key={index}
                  className=" font-Inter text-base font-normal leading-6"
                >
                  {feature.value} {feature.description}
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PlanCard;
